import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout } from "rhombus-react";

import { changeFbPlacement, changeTab } from "reducers/Social";


export default function TabSelector(props){
	let {
		tabs,
		disabledTabs,
		isPlacementTab,
		className,
	} = props;

	const dispatch = useDispatch();
	let selectedPartner = useSelector(state => state.social.selectedTab);
	let selectedPlacement = useSelector(state => state.social.facebookPlacementType);

	let selectedTab = isPlacementTab ? selectedPlacement : selectedPartner;

	function onTabChange(newTab, oldTab){
		if(isPlacementTab) {
			return dispatch(changeFbPlacement(newTab));
		} else {
			return dispatch(changeTab(newTab, oldTab));
		}
	}

	return (
		<Layout.Tabs
			tabs={tabs}
			disabledTabs={disabledTabs}
			onTabChange={onTabChange}
			selectedTab={selectedTab}
			className={`social-preview-tabs ${isPlacementTab ? "placement-tab" : ""} ${className}`}
		/>
	);
}

TabSelector.displayName = "SocialTabSelector";
TabSelector.defaultProps = {
	className:"",
};
